import styled from "styled-components";

export const SFeedbackBar = styled.div`
  position: absolute;
  bottom: 6%;
  width: calc(
    100% - 1.4rem - var(--sidebar-width) - ${(props) => (props.sidePanelVisible ? "var(--panel-width)" : "0px")}
  );

  height: 7%;
  margin-left: 0.7rem;
  margin-right: 0.7rem;
`;

export const SReaction = styled.i`
  position: absolute;
  left: ${(props) => props.left};
  top: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer;
  color: ${(props) => props.color};
`;
